import $ from "jquery";
import "./lib/foundation";
import "./applications_filter";
import objectFitImages from "object-fit-images";

import Mark from "../vendor/mark.js-8.11.1/mark.min";

/* eslint-disable no-unused-vars */
let ticketNumber = null,
    lastTicket = null,
    s1 = 0,
    s2 = 0,
    res = 0,
    submit = null,
    submit2 = null;

window.jQuery = $;
window.$ = $;

const ANIMATION_SPEED = 400,
      SCROLL_WAIT = 500,
      SCROLL_OFFSET = 75,
      MAX_RESIZE_LINE_LENGTH = 40,
      a = 0,
      b = 1,
      c = 5000,
      d = 60;

// Activate poly fill for object-fit
objectFitImages();

$(document).foundation();

/**
 * JS for the main navigation.
 * Also remove the navigation page content if the navigation is opened
 */
$("button[data-button-for]").click(function toggleNavigation() {
  // Get the "button-for" data attribute and the content
  // element that belongs to it
  const data = $(this).data("button-for"),
        content = $(`.main-navigation__content[data-content-id=${data}]`),

        // Check if needed content element is already open
        isOpen = content.hasClass("is-active__content");

  // Reset the navi state completly
  $(".main-navigation__content").removeClass("is-active__content");
  $("button.main-navigation__title").removeClass("active");
  $("button.main-navigation__title").removeClass("not-active");
  $(".sub-navigation-page").css("display", "block");

  // Open the correct element
  if (!isOpen) {
    $(".sub-navigation-page").css("display", "none");
    content.addClass("is-active__content");
    $(this).addClass("active");
    $("button.main-navigation__title").not(this)
      .addClass("not-active");
  }


  // Trigger the resize event to notify all equal-height watchers
  $(window).trigger("resize");
});


/**
 * A cross browser solution to get the query paramets of a url
 * @param name
 * @param url
 * @return {null}
 */
function gup(name, url) {
  if (!url) {
    // eslint-disable-next-line no-param-reassign
    url = location.href;
  }
  // eslint-disable-next-line no-param-reassign
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const regexS = `[\\?&]${name}=([^&#]*)`,
        regex = new RegExp(regexS),
        results = regex.exec(url);
  return results === null ? null : results[1];
}

/**
 * Scrolls to the given element - given offset
 * @param element
 * @param offset
 */
function scrollToElement(element, offset) {
  const position = $(element).offset().top - offset;
  $("html, body").animate({ scrollTop: position }, ANIMATION_SPEED);
}

/**
 * Check if the current page has a search parameter
 * and if so, go and highlight the search parameter on the page
 */
let searchParam = gup("search", window.location);
if (searchParam !== undefined && searchParam !== null && searchParam !== "") {
  searchParam = window.decodeURIComponent(searchParam);
  const instance = new Mark(document.querySelector("body"));
  instance.mark(searchParam, {
    ignorePunctuation: ":;.,-–—‒_(){}[]!'\"+=".split(""),
    done() {
      const results = $(".content").find("mark");
      if (results.length > 0) {
        // Check if the highlighted results are within an accordions
        results.each(function openAccordion(index, element) {
          // eslint-disable-next-line no-param-reassign
          element = $(element);
          if (element.closest("[data-accordion]").length > 0) {
            element.closest("[data-accordion]").foundation("down", element.closest(".accordion-content"), false);
          }
        });

        const firstHighlightedResult = $(results[0]);
        window.setTimeout(scrollToElement, SCROLL_WAIT, firstHighlightedResult, SCROLL_OFFSET);
      }
    },
  });
}

/**
 * Auto-resize textareas as needed.
 */
$("textarea.resizeable").each(function makeTextareasResizeable() {
  this.setAttribute("style", `height:${this.scrollHeight}px;overflow-y:hidden;`);
})
  .on("input", function resizeTextarea() {
    if ($(this).val().length > MAX_RESIZE_LINE_LENGTH || $(this).val()
      .match("\n") !== null) {
      this.style.height = "auto";
      this.style.height = `${this.scrollHeight}px`;
    } else {
      this.style.height = "";
    }
  });


/* eslint-disable func-names */
$(document).ready(function() {
  $.ajax({
    type    : "GET",
    dataType: "json",
    url     : "https://cqm.cleverq.de/api/external/v2/sites?customer_url_name=pro_arbeit_offenbach",
    async   : false,

    success: function success(data) {
      lastTicket = data[a].service_states[a].last_called_ticket;
      document.getElementById("last_ticket_number").textContent = lastTicket;
      document.getElementById("last_ticket_number2").textContent = lastTicket;
      lastTicket = lastTicket.substr(b);
    },
  });

  window.setInterval(function() {
    $.ajax({
      type    : "GET",
      dataType: "json",
      url     : "https://cqm.cleverq.de/api/external/v2/sites?customer_url_name=pro_arbeit_offenbach",
      async   : false,

      success: function success(data) {
        lastTicket = data[a].service_states[a].last_called_ticket;
        document.getElementById("last_ticket_number").textContent = lastTicket;
        document.getElementById("last_ticket_number2").textContent = lastTicket;
        lastTicket = lastTicket.substr(b);
      },
    });
  }, c * d);
});

/**
 * It get the ticket for desktop
 */
submit = document.getElementById("submit");

submit.addEventListener("click", function() {
  ticketNumber = document.getElementById("ticket_number").value;
  //  ticketNum = ticketNumber;
  if (ticketNumber !== null) {
    if(isNaN(ticketNumber.charAt(0))) {
      ticketNumber = ticketNumber.substr(b);
    }

    if(!isNaN(ticketNumber)) {
      s1 = ticketNumber;
      s2 = lastTicket;

      if (lastTicket === "-") {
        document.getElementById("p_number").textContent = "kein Ticket verfügbar";
      } else if (s1 < s2) {
        document.getElementById("p_number").textContent = "Ungültige Ticketnummer";
      } else if (s1 === s2) {
        document.getElementById("p_number").textContent = "Sie sind jetzt an der Reihe";
      } else {
        /* eslint-disable prefer-template */
        res = s1 - s2;
        document.getElementById("p_number").textContent = "Es sind " + res + " Personen vor Ihnen.";
      }
    } else if (isNaN(ticketNumber)) {
      document.getElementById("p_number").textContent = "Ungültige Ticketnummer";
    }
  } else if (ticketNumber === null) {
    document.getElementById("p_number").textContent = "Ungültige Ticketnummer";
  }
}, false);

/**
 * It get the ticket for mobile
 */
submit2 = document.getElementById("submit2");

submit2.addEventListener("click", function() {
  ticketNumber = document.getElementById("ticket_number2").value;
  //  ticketNum = ticketNumber;

  if (ticketNumber !== null) {
    if(isNaN(ticketNumber.charAt(0))) {
      ticketNumber = ticketNumber.substr(b);
    }
    if(!isNaN(ticketNumber)) {
      s1 = ticketNumber;
      s2 = lastTicket;

      if (lastTicket === "-") {
        document.getElementById("p_number2").textContent = "kein Ticket verfügbar";
      } else if (s1 < s2) {
        document.getElementById("p_number2").textContent = "Ungültige Ticketnummer";
      } else if (s1 === s2) {
        document.getElementById("p_number2").textContent = "Sie sind jetzt an der Reihe";
      } else {
        /* eslint-disable prefer-template */
        res = s1 - s2;
        document.getElementById("p_number2").textContent = "Es sind " + res + " Personen vor Ihnen.";
      }
    } else if (isNaN(ticketNumber)) {
      document.getElementById("p_number2").textContent = "Ungültige Ticketnummer";
    }
  } else if (ticketNumber === null) {
    document.getElementById("p_number2").textContent = "Ungültige Ticketnummer";
  }
}, false);



// WEBPACK FOOTER //
// ./src/assets/js/app.js